<template>
    <SportradarLogo class="sr-brand-logo" />
</template>

<script>
import SportradarLogo from '../../assets/sportradar-logo.svg';

export default {
    name: 'SrBrandLogo',
    components: { SportradarLogo },
};
</script>
